<template>
  <b-navbar toggleable="lg" type="dark">
    <b-navbar-brand href="/" class="d-none d-md-block" />
    <b-navbar-toggle target="nav-collapse" />
    <b-collapse id="nav-collapse" is-nav>
      <!-- Gestión -->
      <b-nav vertical class="p-0" v-if="loggedIn">
        <sidebar-item to="/ofertas" title="Propuestas" icon="check-square" />
        <sidebar-item to="/clientes" title="Clientes" icon="users" />
        <sidebar-item to="/contratos" title="Contratos" icon="layers" v-if="esAdmin || esPartner || esResponsable" />
        <sidebar-item to="/repositorioComercial" title="Repositorio Comercial" icon="archive" />
      </b-nav>

      <!-- OPCIONES EXCLUSIVAS MENÚ PERFIL ADMINISTRADOR -->

      <!-- Módulos -->
      <details open v-if="esAdmin">
        <summary title="Módulos">Módulos</summary>
        <b-nav vertical class="p-0">
          <sidebar-item to="/modulos" title="Módulos" icon="database" />
          <sidebar-item to="/preciosHora" title="Precios / hora" icon="clock" />
          <sidebar-item to="/plantillasContenido" title="Plantillas de contenido" icon="globe" />
        </b-nav>
      </details>

      <!-- Configuración general -->
      <details open v-if="esAdmin">
        <summary title="Configuraciones de venta">Configuraciones de venta</summary>
        <b-nav vertical class="p-0">
          <sidebar-item to="/campanias" title="Campañas" icon="at-sign" />
          <sidebar-item to="/tarifas" title="Tarifas" icon="dollar-sign" />
          <sidebar-item to="/planes" title="Planes" icon="package" />
          <sidebar-item to="/descuentos" title="Descuentos" icon="percent" />
          <sidebar-item to="/duracionesContrato" title="Duraciones de contrato" icon="watch" />
          <sidebar-item to="/formasPago" title="Formas de pago" icon="credit-card" />
        </b-nav>
      </details>

      <!-- Otros maestros -->
      <details v-if="esAdmin">
        <summary title="Otros maestros">Otros maestros</summary>
        <b-nav vertical class="p-0">
          <sidebar-item to="/paises" title="Países" icon="flag" />
          <sidebar-item to="/divisas" title="Divisas" icon="dollar-sign" />
          <sidebar-item to="/origenOferta" title="Origen de oferta" icon="package" />
          <sidebar-item to="/unidadesNegocio" title="Unidades de Negocio" icon="server" />
          <sidebar-item to="/motivosCierreOferta" title="Motivos de cierre" icon="layers" />
          <sidebar-item to="/complejidadesProyecto" title="Complejidades de proyecto" icon="shuffle" />
          <sidebar-item to="/plantillasContrato" title="Plantillas de contrato" icon="layers" />
          <sidebar-item to="/usuarios" title="Usuarios" icon="users" />
        </b-nav>
      </details>

      <!-- Estadísticas -->
      <details v-if="esAdmin">
        <summary title="Estadísticas">Estadísticas</summary>
        <b-nav vertical class="p-0">
          <sidebar-item to="/estadisticas/ofertas" title="Estadísticas de ofertas" icon="trending-up" />
          <sidebar-item to="/estadisticas/modulos" title="Estadísticas de módulos" icon="trending-up" />
          <sidebar-item to="/estadisticas/ofertasEntregadas" title="Ofertas Entregadas" icon="inbox" />
        </b-nav>
      </details>

      <b-nav vertical class="p-0 b-nav-logout" v-if="loggedIn">
        <!-- CERRAR SESSIÓN -->
        <b-nav-item :title="tooltipCerrarSesion" @click="logout" v-b-tooltip.hover>
          <v-icon name="log-out" width="16" />
          <span class="sm-hidden">Cerrar Sesión</span>
        </b-nav-item>
      </b-nav>
    </b-collapse>
  </b-navbar>
</template>
<script>
import { mapState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import SidebarItem from "./sidebar-item.vue";

export default {
  components: {
    SidebarItem,
  },
  computed: {
    ...mapState(useSessionStore, ["loggedIn", "usuarioId", "nombre", "esAdmin", "esResponsable", "esPartner"]),
    tooltipCerrarSesion() {
      return `${this.nombre} ~ v${process.env.VUE_APP_VERSION}`;
    },
  },
  methods: {
    async logout() {
      const ok = await this.$bvModal.msgBoxConfirm("¿Desea cerrar la sesión?", {
        title: "Atención",
        okTitle: "Cerrar sesión",
      });

      if (ok) {
        this.$emit("logout");
      }
    },
  },
};
</script>
